import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Observable, of, EMPTY } from 'rxjs';
import { catchError, map, take } from 'rxjs/operators';

import { OptionSetsApiService } from '../data-services/index';
import { IOptionSets } from '@ebb-v2/ebb-integration';

export interface IOptionList {
    id: string;
    optionSets: IOptionSets[];
  }

@Injectable({
    providedIn: 'root'
  })
export class ApplicationResolver implements Resolve<any> {

  constructor(
      private http: HttpClient,
      private apiOptionSets: OptionSetsApiService
      ) { }

  resolve(): Observable<any> {
    return this.apiOptionSets
    .getList('application')
    .pipe(map(
      response => response
     ),
     take(1),
     catchError(err => of(err)));
  }
}